import { useDispatch, useSelector } from "react-redux";
import { SignupCard } from "../components/SignUpCard";
import { RootState } from "../redux/store";
import { setSignupModalState } from "../redux/slices/popupModalSlices";
import { useState } from "react";
import { login } from "../redux/slices/authSlice";
import { checkEmailExists } from "../services/validationService";
import { registerCall } from "../services/authService";
import { SignupCredentials } from "../types/userData.types";

export default function SignUp() {
  const dispatch = useDispatch();
  const isModalVisible = useSelector(
    (state: RootState) => state.popup.showSignupModal
  );
  const [fieldErrors, setFieldErrors] = useState({});

  const handleClose = () => {
    dispatch(setSignupModalState(false));
  };

  if (!isModalVisible) return null;

  const handleOnSubmit = async (result: SignupCredentials) => {
    const { data, error } = await registerCall(result);

    if (data && data?.token) {
      handleClose();
      dispatch(login(data));
    } else {
      setFieldErrors(error);
      console.error("Registration failed:", error);
    }
  };

  const handleEmailChange = async (email: string) => {
    checkEmailExists(email)
      .then((res) => {
        console.log("Email check result:", res);
        if (res?.exists) {
          setFieldErrors((prev) => ({
            ...prev,
            email: res?.message,
          }));
        } else {
          setFieldErrors((prev) => ({
            ...prev,
            email: null,
          }));
        }
      })
      .catch(() => {
        console.error("Email check failed");
      });
  };

  return (
    <SignupCard
      fieldErrors={fieldErrors}
      onSubmit={handleOnSubmit}
      onClose={handleClose}
      setFieldErrors={setFieldErrors}
      onEmailChange={handleEmailChange}
    />
  );
}
